import { useZodValidation } from "@/features/core-shared/composables/useZodValidation";
import { usePrimitiveModelWithChanges } from "@/features/core-shared/composables/usePrimitiveModelWithChanges";
import { experienceTitleSchema } from "@/features/experience-shared/schemas/experience-title.schema";

export function useTitleValidation(initialValue: Ref<string>) {
  const { $t } = useNuxtApp();
  const { model, hasChanges, isFilled, reset } = usePrimitiveModelWithChanges(initialValue);
  const { errors, isValid } = useZodValidation(experienceTitleSchema, model);

  const errorMessage = computed(() => $t(errors.value?.errors?.join(",") || ""));

  return {
    model,
    hasChanges,
    isFilled,
    errors,
    errorMessage,
    isValid,
    reset,
  };
}
